module.exports = __webpack_public_path__ + "img/order.6b11eb0e.png";